import React, { useState } from 'react';
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import 'date-fns';
import es from "date-fns/locale/es";
import {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBCard,
    MDBCardBody,
    MDBInput,
    MDBBtn,
    MDBModalFooter,
    MDBModal,
    MDBModalBody
} from 'mdbreact';

import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import axios from 'axios';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import "react-datepicker/dist/react-datepicker.css";

require('dotenv').config();

const API_PATH = process.env.REACT_APP_API_URL+'php/includes/createNotificationOrder.php';

const isMorethanToday = (someDate) => {
    const today = new Date()
    return someDate.getTime() > today.getTime()
}

registerLocale('es', es)
class PrecitaReferentesResonaForm extends React.Component {
    
    constructor(props) {
        super(props);
        this.dataform = {
            destination:"alberto.miranda@iststorage.com",
            msg:"/opt/ist/data/desknova/resources/html/correoAlta.html",

            nombre:'',
            apellidos:'',
            num_historia:'',
            fecha_solicitada:'',
            lo_antes_posible:false,
            medico_referente:''
        };

        this.state = {
            showAlert: false,
            errorMessage:"Error: Debe informar una fecha posterior a hoy o seleccionar 'Lo antes posible'",
            sentMessage:"Su petición de cita ha sido efectuada correctamente. Muchas gracias.",
            mailSent:false,
            selectedClass:'notSelected',
            selectedDate: new Date()
        };

        this.errorMessage = '';

        this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
        this.handleLastNameChange = this.handleLastNameChange.bind(this);
        this.handleHistoryNumberChange = this.handleHistoryNumberChange.bind(this);
        this.handleLoAntesPosibleChange = this.handleLoAntesPosibleChange.bind(this);
        this.handleReferringPhysicianNameChange = this.handleReferringPhysicianNameChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }


    handleFirstNameChange(event) { this.dataform.nombre = event.target.value; }
    handleLastNameChange(event) { this.dataform.apellidos = event.target.value; }
    handleHistoryNumberChange(event) { this.dataform.num_historia = event.target.value; }
    handleLoAntesPosibleChange(event) {this.dataform.lo_antes_posible = event.target.checked; }
    handleReferringPhysicianNameChange(event) { this.dataform.medico_referente = event.target.value; }
    handleDateChange = date => {
        this.setState({
            selectedDate: date
        });
    };

    handleSubmit(event) {
        var success = true;
        if(this.dataform.lo_antes_posible == false && !isMorethanToday(this.state.selectedDate)) {
            this.setState({
                showAlert: !this.state.showAlert
            });
        }else{
            if(this.dataform.lo_antes_posible == false) this.dataform.lo_antes_posible = "false";
            if(this.dataform.lo_antes_posible == true) this.dataform.lo_antes_posible = "true";
            this.dataform.fecha_solicitada = this.state.selectedDate;
            this.sendInfo();
        }
        event.preventDefault();
    }
    sendInfo(){
        axios({
            method: 'post',
            url: `${API_PATH}`,
            headers: { 'content-type': 'application/json' },
            data: this.dataform
        }).then(result => {
            if(result.status==200){
                if(result.data.success){
                    this.setState(
                        { mailSent: true }
                    );

                }else{
                    this.setState(
                        {
                            showSQLAlert:true,
                            sqlErrorMessage: this.parseSqlError(result.data)
                        }
                    )
                }
            }else{
                this.setState(
                    { error: result.data.message }
                )
            }
        }).catch(error => {
                this.setState(
                    { error: error.message }
                )
            }
        );
    }
    handleNotShowMessage(){
        console.log("NOT SHOWING");
        this.setState({
            showAlert: false
        });
    }

    toggle = () => {
        this.setState({
            showAlert: !this.state.showAlert
        });
    };
    toggleMail = () => {
        this.setState({
            mailSent:  !this.state.mailSent,
        });
    };
    toggleSql = () => {
        this.setState({
            showSQLAlert:  !this.state.showSQLAlert,
        });
    };


    render() {
        return (
            <div className="row d-flex justify-content-center">
                <div className="col-md-8 modal-lg">
                    <MDBContainer>
                        <MDBModal isOpen={this.state.mailSent} toggle={this.toggleMail} size="lg" centered>
                            <MDBModalBody>
                                <img className="successImage" src={ process.env.REACT_APP_IMAGE_PATH+'greenStick.svg.png'} />
                                {this.state.sentMessage}
                            </MDBModalBody>
                            <MDBModalFooter>
                                <MDBBtn color="secondary" onClick={this.toggleMail}>Close</MDBBtn>
                            </MDBModalFooter>
                        </MDBModal>
                    </MDBContainer>

                    <MDBContainer>
                        <MDBModal isOpen={this.state.showSQLAlert} toggle={this.toggleSql} side position="top-right" dismiss>
                            <MDBModalBody>
                                {this.state.sqlErrorMessage}
                            </MDBModalBody>
                            <MDBModalFooter>
                                <MDBBtn color="secondary" onClick={this.toggleSql}>Close</MDBBtn>
                            </MDBModalFooter>
                        </MDBModal>
                    </MDBContainer>

                    <MDBContainer>
                        <MDBModal isOpen={this.state.showAlert} toggle={this.toggle} side position="top-right" dismiss>
                            <MDBModalBody>
                                {this.state.errorMessage}
                            </MDBModalBody>
                            <MDBModalFooter>
                                <MDBBtn color="secondary" onClick={this.toggle}>Close</MDBBtn>
                            </MDBModalFooter>
                        </MDBModal>
                    </MDBContainer>
                    <form onSubmit={this.handleSubmit}>
                        <MDBContainer>
                            <MDBRow>
                                <MDBCol>
                                    <MDBCard>
                                        <MDBCardBody className="mx-4">
                                            <img className="logo" src={ process.env.REACT_APP_IMAGE_PATH+'logo_resona.jpg'} />
                                            <div className="text-center">
                                                <h3 className="dark-grey-text mb-5">
                                                    <strong>Pre-Cita de Referentes</strong>
                                                </h3>
                                            </div>
                                            <MDBInput
                                                className="mb-3"
                                                type="text"
                                                label="Escriba aquí el nombre del paciente"
                                                name="first_name"
                                                onChange={this.handleFirstNameChange}
                                            />
                                            <MDBInput
                                                label="Escriba aquí los apellidos del paciente"
                                                type="text"
                                                name="last_name"
                                                onChange={this.handleLastNameChange}
                                            />

                                            <MDBInput
                                                type="text"
                                                label="Informe aquí el número de historia"
                                                name="num_historia"
                                                onChange={this.handleHistoryNumberChange}
                                            />

                                            <label class="text-black-50 disabled" width="100%">Seleccione la fecha que desea para su prueba diagnóstica.</label>
                                            <div className="text-left mt-auto mb-3">
                                                <DatePicker
                                                    class=""
                                                    dateFormat="dd/MM/yyyy"
                                                    locale="es"
                                                    selected={this.state.selectedDate}
                                                    onChange={this.handleDateChange}
                                                />
                                            </div>

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        onChange={this.handleLoAntesPosibleChange}
                                                        value="lo_antes_posible"
                                                        color="primary"
                                                    />
                                                }
                                                label="Lo antes posible"
                                            />

                                            <MDBInput
                                                className="mb-3"
                                                type="text"
                                                label="Escriba aquí su nombre y apellidos"
                                                name="first_name"
                                                onChange={this.handleReferringPhysicianNameChange}
                                            />


                                            <div className="text-center mb-3">
                                                <MDBBtn
                                                    type="submit"
                                                    value="Submit"
                                                    gradient="blue"
                                                    rounded
                                                    className="btn-block z-depth-1a"
                                                >
                                                    Solicitar Cita
                                                </MDBBtn>
                                            </div>
                                        </MDBCardBody>

                                        <MDBModalFooter className="mx-5 pt-3 mb-1">
                                            <p className="font-small grey-text d-flex justify-content-end muypequeña">
                                                Developed by IST Medical
                                            </p>
                                        </MDBModalFooter>
                                    </MDBCard>
                                </MDBCol>
                            </MDBRow>
                        </MDBContainer>
                    </form>
                </div>
            </div>
        );
    }


    parseSqlError(data){
        var errorCodeMsg = data.logMessages[data.logMessages.length -1];
        var errorCode = (errorCodeMsg.replace("[SQL_ERR_Code] - ","")).trim();

        if(errorCode == 1062){
            return "Doctor KV already exists. Have you forgotten your credentials?";
        }else{
            return data.message;
        }
    }
}

export default PrecitaReferentesResonaForm;

